import Cookies from "js-cookie";

import { configureStore } from '@reduxjs/toolkit';
import summationsiteReducer from '../features/summationsite/summationsiteSlice';
import userrequestReducer from '../features/userrequest/userrequestSlice';
import smartmeterReducer from '../features/smartmeter/smartmeterSlice';
import vehicleReducer from '../features/vehicle/vehicleSlice';
import optimizationReducer from '../features/optimization/optimizationSlice';
import predictionReducer from '../features/prediction/predictionSlice';
import buildingforecastReducer from '../features/buildingforecast/buildingforecastSlice';
import currentstatusReducer from '../features/currentstatus/currentstatusSlice';
import sumchargeReducer from '../features/sumcharge/sumchargeSlice';
import uidataReducer from '../features/uidata/uidataSlice';
import priceReducer from '../features/price/priceSlice';
import netloadReducer from '../features/netload/netloadSlice';
import evstatusReducer from '../features/evstatus/evstatusSlice';
import activecarinfoReducer from '../features/activecarinfo/activecarinfoSlice';
import targetdemandReducer from '../features/targetdemand/targetdemandSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import batterystatusReducer from '../features/batterystatus/batterystatusSlice';
import vehicledetailsReducer from '../features/vehicledetails/vehicledetailsSlice'
import chartsReducer from '../features/charts/chartsSlice';
import strategyEvaluationReducer from '../features/strategyEvaluation/strategyEvaluationSlice';

import carinfodetailsReducer from '../features/carinfodetails/carinfodetailsSlice'
import analyticsAggregationReducer from '../features/analytics/analyticsAggregationSlice';

const loadStateFromCookies = () => {
  try {
    const stateFromCookie = Cookies.get("reduxState");
    if (false && stateFromCookie) {
      const parsedState = JSON.parse(stateFromCookie);
      // Add an expiration check (if needed)
      return parsedState;
    }
  } catch (error) {
    console.error("Failed to load state from cookie", error);
  }
  return undefined;
};
const preloadedState = loadStateFromCookies();
const store = configureStore({
  reducer: {
    activecarinfo: activecarinfoReducer,
    summationsite: summationsiteReducer,
    optimization: optimizationReducer,
    prediction: predictionReducer,
    smartmeter: smartmeterReducer,
    vehicle: vehicleReducer,
    buildingforecast: buildingforecastReducer,
    currentstatus: currentstatusReducer,
    sumcharge: sumchargeReducer,
    uidata: uidataReducer,
    price: priceReducer,
    netload: netloadReducer,
    evstatus: evstatusReducer,
    targetdemand: targetdemandReducer,
    batterystatus: batterystatusReducer,
    vehicledetails: vehicledetailsReducer,
    userrequest: userrequestReducer,
    charts: chartsReducer,
    strategyEvaluation: strategyEvaluationReducer,
    dashboard: dashboardReducer,

    carinfodetails: carinfodetailsReducer,
    analyticsAggregation: analyticsAggregationReducer,
    
  },
  preloadedState
});

// Save state to cookies on store updates
store.subscribe(() => {
  const temp = {
    ...store.getState(),
    timestamp: Date.now(),
  };
  const stateToSave = {
    uidata: temp.uidata,
  }
  // Cookies.set("reduxState", JSON.stringify(stateToSave), { expires: 0.5 });
});


export default store;